export enum LoaderContainerBlock {
  Root = 'LoaderContainer',
}

export enum LoaderContainerModifier {
  Absolute = 'absolute',
}
